import type { KeyboardEvent } from 'react';
import { PencilSquareIcon } from '@interstate/components/Icons/PencilSquareIcon';
import { NumericInput } from '@interstate/components/NumericInput';
import { DUE_AT_SIGNING } from '../constants';
import { editLabelStyle, labelContainerStyle, labelStyle, labelTextStyle } from '../dealSummary/common/ComponentLabelStyle';

const label = DUE_AT_SIGNING;

interface SummaryDueAtSigningLabelAndNumberProps {
    toggleSlideOut: () => void;
    inputValue?: string;
}

const SummaryDueAtSigningLabelAndNumber = ({ toggleSlideOut, inputValue }: SummaryDueAtSigningLabelAndNumberProps) => {
    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleSlideOut();
        }
    };

    return (
        <>
            <div
                onClick={toggleSlideOut}
                onKeyDown={handleKeyDown}
                style={{ ...labelContainerStyle, cursor: 'pointer' }}
                tabIndex={0}
                role="button"
            >
                <label data-testid={'due-at-signing-summary-label'} style={labelStyle}>
                    <span style={labelTextStyle}>{label}</span>
                    <PencilSquareIcon aria-label="Due At Signing Summary Edit" />
                    <span style={editLabelStyle}>Edit</span>
                </label>
            </div>
            <NumericInput
                size="sm"
                sx={{ lineHeight: '1.938rem' }}
                displayLabel={false}
                name={label}
                data-testid={'due-at-signing-summary-numeric-value'}
                readOnly={true}
                value={inputValue}
                inputPrefix={'$'}
                allowDecimal={true}
            />
        </>
    );
};

export default SummaryDueAtSigningLabelAndNumber;
